import AxiosInstance from 'src/shared/services/axios/interceptor';
import { SendArticle } from 'src/modules/sending/models/sendArticle';
import { SendingDate } from 'src/modules/sending/models/sendingDate';
import { Sending } from 'src/modules/sending/models/sending';
import { SendingOrder } from 'src/modules/sending/models/sendingOrder';
import { SendingOrderCreate } from 'src/modules/sending/models/sendingOrderCreate';
import { SendingOrderProduct } from 'src/modules/sending/models/sendingOrderProduct';
import { PagedResult } from 'src/shared/models/pagedResult';
import { setPagingParams } from 'src/shared/functions/createPagingParams';

const controller = 'Sending';

export const getAllSendingDates = (pageIndex, pageSize, sortCol, sortDir, bookingDeadlineDays?: number) => {
  let endpoint = `SendingDate/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  // Backend kan filtrera bort datum som ligger inom bokningsstoppet (t.ex. 7 dagar framåt)
  if (bookingDeadlineDays !== undefined) {
    endpoint += `&bookingDeadlineDays=${bookingDeadlineDays}`;
  }
  return AxiosInstance.get<PagedResult<SendingDate>>(endpoint);
};

// Hämtar ett enskilt utskicksdatum (SendingDate) via id – används som fallback när GET-beställningen inte
// populerar date-objektet.
export const getSendingDateById = (id: number) => {
  return AxiosInstance.get<SendingDate>(`SendingDate/${id}`);
};

// Backend returnerar numera en ren lista (SendingOrderProduct[]), inte ett PagedResult
export const getAllSendingOrderProduct = () => {
  return AxiosInstance.get<SendingOrderProduct[]>('SendingOrderProduct');
};

// Prissättningsartiklar (snd_articles) för att beräkna kostnaden i utskickets sammanfattning.
export const getSendArticles = () => {
  return AxiosInstance.get<SendArticle[]>('SendingOrder/Articles');
};

export const getAllSendingOrder = (pageIndex, pageSize, sortCol, sortDir) => {
  const endpoint = `SendingOrder/?${setPagingParams({ pageIndex, pageSize, sortCol, sortDir })}`;
  return AxiosInstance.get<PagedResult<SendingOrder>>(endpoint);
};

export const deleteSendingOrder = (id) => {
  const endpoint = `SendingOrder/${id}`;
  return AxiosInstance.delete<SendingOrder>(endpoint);
};

export const updateSendingOrder = (sendingOrder: SendingOrder) => {
  const endpoint = `SendingOrder`;
  return AxiosInstance.put<SendingOrder>(endpoint, sendingOrder);
};

export const saveSendingOrder = (sendingOrder: SendingOrderCreate) => {
  const endpoint = `SendingOrder`;
  return AxiosInstance.post<SendingOrderCreate>(endpoint, sendingOrder);
};

export const getSendingById = (id) => {
  const endpoint = `${controller}/${id}`;
  return AxiosInstance.get<Sending>(endpoint);
};

export const getSendingOrderById = (id) => {
  const endpoint = `SendingOrder/${id}`;
  return AxiosInstance.get<SendingOrder>(endpoint);
};

// ---- Beställda fakturapåminnelser (Påminnelse 1 & 2) ----

export type SendingOrderReminderRequest = {
  // eslint-disable-next-line camelcase
  date_id: number;
  payDate: string;
  deliveryMethodOrder: string;
  invoiceHeading: string;
  invoiceText: string;
  emailHeading: string;
  emailText: string;
  // "Jag kompletterar senare": påminnelsen bokas men får status Komplettering behövs tills texterna fylls i.
  completeLater: boolean;
};

// Hur många som skulle få påminnelsen om den producerades nu, och hur de är mottagliga.
// generated = false betyder att huvudutskicket inte genererat fakturor ännu – då finns inget att räkna på.
export type SendingOrderReminderRecipients = {
  generated: boolean;
  total: number;
  email: number;
  kivra: number;
  letter: number;
  kivraAvailable: boolean;
  asOf: string;
};

export const orderSendingOrderReminder = (id: number, which: 1 | 2, data: SendingOrderReminderRequest) => {
  const endpoint = `SendingOrder/${id}/reminder/${which}`;
  return AxiosInstance.put<SendingOrder>(endpoint, data);
};

export const getSendingOrderReminderRecipients = (id: number, which: 1 | 2) => {
  const endpoint = `SendingOrder/${id}/reminder/${which}/recipients`;
  return AxiosInstance.get<SendingOrderReminderRecipients>(endpoint);
};
